import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../../components/ui/Container';
import Accordion from '../../../components/ui/Accordion';
import TextReveal from '../../../components/ui/TextReveal';
import ScrollReveal from '../../../components/ui/ScrollReveal';

const FAQSection = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <section className="relative py-section overflow-hidden" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
      {/* Dot grid background */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle, var(--color-text-primary) 1px, transparent 1px)',
          backgroundSize: '20px 20px',
        }}
      />

      <Container size="narrow" className="relative z-10">
        <div className="text-center mb-10 md:mb-14">
          <motion.span
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="inline-block px-3 py-1 mb-4 text-sm font-semibold text-brand-500 bg-brand-100 rounded-pill"
          >
            FAQ
          </motion.span>
          <TextReveal
            text="Frequently Asked Questions"
            as="h2"
            mode="word"
            stagger={0.06}
            className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-[var(--color-text-primary)] text-balance"
          />
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="mt-4 text-lg text-[var(--color-text-secondary)] max-w-2xl mx-auto leading-relaxed"
          >
            Everything you need to know about our programs.
          </motion.p>
        </div>

        <ScrollReveal animation="fade-up">
          <div className="relative bg-[var(--color-bg-card)] rounded-2xl border border-[var(--color-border-card)] shadow-card p-6 md:p-8">
            {/* Gradient accent line on left */}
            <div
              className="absolute left-0 top-6 bottom-6 w-1 rounded-full"
              style={{ background: 'linear-gradient(to bottom, #5396BD, #64B2FF, #3F6BAA)' }}
            />
            <div className="pl-4">
              <Accordion items={data} />
            </div>
          </div>
        </ScrollReveal>
      </Container>
    </section>
  );
};

export default FAQSection;
